export type IconProps = React.HTMLAttributes<SVGElement>;

export const TopScrollIcon = (props: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="12" viewBox="0 0 20 12" fill="none" {...props}>
    <path
      d="M17.7782 10.159L10 2.38086L2.22183 10.159"
      stroke="white"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
